import { Check, X } from "lucide-react";
import styles from "./Toast.module.css";

const COLORS = {
    success: {
        accent: "#22c55e",
        accentSoft: "#dcfce7"
    },
    warning: {
        accent: "#eab308",
        accentSoft: "#fef9c3"
    },
    info: {
        accent: "#3b82f6",
        accentSoft: "#dbeafe"
    },
    error: {
        accent: "#ef4444",
        accentSoft: "#fee2e2"
    },
    default: {
        accent: "#737373",
        accentSoft: "#e5e5e5"
    }
};

export default function Toast({ type = "success", message, title, onClose }) {
    const c = COLORS[type] || COLORS.default;

    return (
        <div
            className={`
                w-80 p-4 rounded-2xl shadow-lg border
                bg-white/95 dark:bg-zinc-900/95
                border-zinc-200 dark:border-zinc-700
                ${styles.animateToastIn}
            `}
        >
            <div className="flex gap-3">

                {/* LEFT ICON BOX */}
                <div
                    className="w-8 h-8 rounded-lg flex items-center justify-center"
                    style={{
                        backgroundColor: c.accentSoft,
                        color: c.accent
                    }}
                >
                    {type === "error" ? (
                        <X size={18} strokeWidth={2.5} />
                    ) : (
                        <Check size={18} strokeWidth={2.5} />
                    )}
                </div>

                {/* TEXT */}
                <div className="flex-1">
                    <div className="font-semibold text-gray-900 dark:text-gray-100 text-[15px]">
                        {title}
                    </div>

                    <div className="text-gray-600 dark:text-gray-300 text-sm mt-0.5 leading-snug">
                        {message}
                    </div>
                </div>

                {/* CLOSE ICON BOX — FULL TAILWIND */}
                <button
                    onClick={onClose}
                    className="
                        w-8 h-8 rounded-lg flex items-center justify-center
                        bg-black/5 text-black/50 
                        hover:bg-black/10 
                        dark:bg-white/10 dark:text-white/60
                        dark:hover:bg-white/20
                        transition
                    "
                >
                    <X size={19} strokeWidth={2.4} />
                </button>

            </div>

            {/* PROGRESS BAR */}
            <div className="mt-4 h-[3px] w-full rounded-full bg-zinc-200 dark:bg-zinc-700 overflow-hidden">
                <div
                    className={`${styles.animateToastProgress} h-full`}
                    style={{ backgroundColor: c.accent }}
                ></div>
            </div>
        </div>
    );
}
